// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"Image_imageWrapper__3cwUV"};